/* eslint-disable max-lines-per-function */
import { useTagebuchEintraege } from '@/domain/controlling/hooks/useTagebuchEintraege';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { t } from 'i18next';
import { useRouteParams } from '../useRouteParams';
import { useHistorie } from '@/domain/controlling/hooks/useHistorie';
import { Historie } from './Historie/Historie';
import { WeatherCard } from './Wetter';
import { InterneNotiz } from './InterneNotiz/InterneNotiz';

export function TagesInformationen({ standortId }: { standortId: string }) {
  const { routeParams, searchParams } = useRouteParams();

  const { tagebuchEintraege } = useTagebuchEintraege({
    standortId,
    jahrMonat: routeParams,
  });

  const tagebuchEintragByDatum = tagebuchEintraege.find(
    (tagebuchEintrag) => tagebuchEintrag.datum === searchParams.datum,
  );

  const weatherOfTheDay =
    tagebuchEintraege.find(
      (tagebuchEintrag) => tagebuchEintrag.datum === searchParams.datum,
    )?.wetter || [];

  const { tagebuchEintragHistorie } = useHistorie({
    standortId,
    datum: searchParams.datum,
  });

  return (
    <Accordion type="multiple">
      <AccordionItem value="wetter">
        {weatherOfTheDay.length > 1 && (
          <AccordionTrigger className="flex justify-start">
            <span className="text-base font-bold">
              {t('widgets.weather.wetter')}
            </span>
          </AccordionTrigger>
        )}
        <AccordionContent>
          {weatherOfTheDay.length > 1 && (
            <WeatherCard
              standortId={standortId}
              weatherOfTheDay={weatherOfTheDay}
            />
          )}
        </AccordionContent>
      </AccordionItem>
      <AccordionItem value="historie">
        {tagebuchEintragHistorie && (
          <AccordionTrigger className="flex justify-start">
            <span className="text-base font-bold">Historie</span>
          </AccordionTrigger>
        )}
        <AccordionContent>
          {tagebuchEintragHistorie && (
            <Historie tagebuchHistorie={tagebuchEintragHistorie} />
          )}
        </AccordionContent>
      </AccordionItem>
      <AccordionItem value="bemerkung">
        <AccordionTrigger className="flex justify-start">
          <span className="text-base font-bold">
            {t(
              'domain.controlling.umsatzplanung.planung.tagesInformation.title',
            )}
          </span>
        </AccordionTrigger>
        <AccordionContent>
          <InterneNotiz interneNotiz={tagebuchEintragByDatum.interneNotiz} />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
